const addBooking = (
  location,
  agentlogin,
  payment,
  payableAmout,
  priceDetails,
  selectedFlight,
  dispatch,
  FlightAddBookingDispatch,
  PGCharge,
  BookingFormData
) => {
  let formaddBooking = {
    orderId: location.state.orderID,
    supplier: location.state.OneflightData.Supplier,
    userEmail: location.state.formData.email,
    userPhone: location.state.formData.phone,
    user_type: agentlogin && agentlogin.status === 200 ? "agent" : "guest",
    origin: location.state.body.Segments[0].Origin,
    destination: location.state.body.Segments[0].Destination,
    travelDate: location.state.body.Segments[0].PreferredDepartureTime,
    returnDate: "",
    journeyType: location.state.body.JourneyType === 1 ? "OneWay" : "",
    origin1: "",
    destination1: "",
    travelDate1: "",
    origin2: "",
    destination2: "",
    travelDate2: "",
    origin3: "",
    destination3: "",
    travelDate3: "",
    PGCharge: payment === "pay" ? 200 : 0,
    class: "Economy",
    nop: `${location.state.body.AdultCount} | ${location.state.body.ChildCount} | ${location.state.body.InfantCount} `,
    airlineType: "",
    carrier: location.state.OneflightData.AirlineCode
      ? location.state.OneflightData.AirlineCode
      : location.state.OneflightData.Airline_Code,
    fareType: "R",
    eTicketType: "eTicket",
    actualFare:
      location.state.OneflightData.Supplier === "TBO"
        ? Number(Math.round(location.state.OneflightData.Fare.Total_Amount)) -
          Number(Math.round(location.state.OneflightData.Fare.markup)) -
          Number(Math.round(location.state.OneflightData.Fare.partnerMarkup)) -
          Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
        : Number(Math.round(location.state.OneflightData.Fares.Total_Amount)) -
          Number(Math.round(location.state.OneflightData.Fares.markup)) -
          Number(Math.round(location.state.OneflightData.Fares.partnerMarkup)) -
          Number(Math.round(location.state.OneflightData.Fares.agentMarkup)),
    markup:
      location.state.OneflightData.Supplier === "TBO"
        ? Math.round(location.state.OneflightData.Fare.markup)
        : Math.round(location.state.OneflightData.Fares.markup),
    baseFare:
      location.state.OneflightData.Supplier === "TBO"
        ? Number(Math.round(location.state.OneflightData.Fare.Total_Amount)) -
          Number(Math.round(location.state.OneflightData.Fare.partnerMarkup)) -
          Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
        : Number(Math.round(location.state.OneflightData.Fares.Total_Amount)) -
          Number(Math.round(location.state.OneflightData.Fares.partnerMarkup)) -
          Number(Math.round(location.state.OneflightData.Fares.agentMarkup)),
    partnerMarkup:
      location.state.OneflightData.Supplier === "TBO"
        ? Math.round(location.state.OneflightData.Fare.partnerMarkup)
        : Math.round(location.state.OneflightData.Fares.partnerMarkup),
    agentMarkup:
      location.state.OneflightData.Supplier === "TBO"
        ? Math.round(location.state.OneflightData.Fare.agentMarkup)
        : Math.round(location.state.OneflightData.Fares.agentMarkup),
    totalFare:
      location.state.OneflightData.Supplier === "TBO"
        ? Number(Math.round(location.state.OneflightData.Fare.Total_Amount)) -
          Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
        : Number(Math.round(location.state.OneflightData.Fares.Total_Amount)) -
          Number(Math.round(location.state.OneflightData.Fares.agentMarkup)),
    payableAmount: payableAmout,
    ticketCost: Number(payableAmout) + Number(payment === "pay" ? 200 : 0),
    totalEarn: 0,
    cashBack: "0.00",
    couponDiscount: 0.0,
    couponDetails: "",
    pricingDetails: priceDetails,
    selectedFlight: selectedFlight,
    airlineType: location.state.OneflightData.Airline_Code
      ? location.state.OneflightData.Block_Ticket_Allowed
        ? "LCC"
        : "GDS"
      : location.state.OneflightData.IsLCC
      ? "LCC"
      : "GDS",
    selectedPax: BookingFormData,
    ticketSent: 0,
    paymentMode: agentlogin
      ? payment === "offline"
        ? "OFFLINE"
        : "ONLINE"
      : "ONLINE",
    agent_id:
      agentlogin && agentlogin.status === 200
        ? agentlogin && agentlogin.result.result.id
        : 0,
  };
  dispatch(FlightAddBookingDispatch(formaddBooking,payment));
  // console.log("add booking", formaddBooking);
};
export default addBooking;
